module.exports = __webpack_public_path__ + "img/processingPayment.50d9a65c.gif";